import styled from 'styled-components';

export const FilterBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin: 10px 0 14px;
`;

export const SearchBox = styled.div`
  flex: 1;
  min-width: 240px;
`;

export const FilterField = styled.div`
  width: 190px;
`;

export const RowAvatarWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 0;
`;

export const RowAvatar = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  background-color: ${({ $bg }) => $bg || '#94a3b8'};
`;

export const TypeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 150px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  text-align: center;
  background-color: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
`;

export const OptionsCell = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
`;
